import { createNavigationContainerRef, StackActions } from '@react-navigation/native'

export const isReadyRef = {
  current: false,
}

export const navigationRef = createNavigationContainerRef<any>()

export function navigate(name, params) {
  if (isReadyRef.current && navigationRef.isReady()) {
    // Perform navigation if the app has mounted
    navigationRef.navigate(name, params)
  } else {
    // You can decide what to do if the app hasn't mounted
    // You can ignore this, or add these actions to a queue you can call later
    // push(name, params);
  }
}

export function push(...args) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.push(...args))
  }
}
